angular.module('SpidApp')

.controller('VacationDetailsController',
		['$scope', '$state', '$stateParams', 'Toaster', 'VacationService', 'SaleService', '_', 'Cash', 'Sale', 'VacationDecorator', 'TransactionService', '$q', 'ConfigService',
function ($scope,   $state,   $stateParams,   Toaster,   VacationService,   SaleService,   _,   Cash,   Sale,   VacationDecorator,   TransactionService,   $q,   ConfigService) {
	var vacationId = +$stateParams.id

	$scope.report = {

	}

	var config = null
	ConfigService.all().then(function (_config) {
		config = _config
		return VacationService.find(config.agencyId, vacationId)
	}).then(function (vacation) {
		$scope.vacation = VacationDecorator(vacation)

		return SaleService.findByVacationId(config.agencyId, vacation.id).then(function (sales) {
			var pool = []
			sales.forEach(function (sale) {
				var p = TransactionService.find(config.agencyId, sale.transactionId).then(function (transaction) {
					sale.transaction = transaction
					return sale
				})
				
				pool.push(p)
			})
			
			return $q.all(pool)
		}).then(function (sales) {
			$scope.sales = _.chain(sales).filter(function (sale) {
				return sale.transaction.finished
			}).value()
			
			$scope.badSales = _.chain(sales).filter(function (sale) {
				return !sale.transaction.finished && sale.type === 'Stamp'
			}).value()
			
			$scope.vacationOngoing = moment(vacation.dateStart).calendar()
			
			$scope.salesByTransaction = _.chain($scope.sales).groupBy('transactionId').mapObject(function(value) {
				return {
					transaction           : value[0].transaction, 
					transactionLocalTotal : Sale.totalPrice(value),
					sales                 : value, 
					opened                : false
				};
			}).value();
			
			$scope.badSalesByTransaction = _.chain($scope.badSales).groupBy('transactionId').mapObject(function(value) {
				return {
					transaction: value[0].transaction, 
					transactionLocalTotal : Sale.totalPrice(value), 
					sales: value, 
					opened: false
				};
			}).value();
			
			$scope.salesTotalPrice = Sale.totalPrice($scope.sales)

			$scope.report.refundSaleQuantity = (_.reduce($scope.sales, function (memo, sale) {
				return memo + (sale.isRefund() ? sale.quantity : 0)
			}, 0) + $scope.badSales.length )
			
			$scope.report.refundSalePrice = (_.reduce($scope.sales, function (memo, sale) {
				return memo + (sale.isRefund() ? sale.quantity * sale.localPrice : 0)
			}, 0) + _.reduce($scope.badSales, function (memo, sale) {
				return memo + sale.quantity * sale.localPrice
			}, 0) )
		})
	}) 

	$scope.validateVacation = function (vacation) {
		vacation.setValidated()
		VacationService.save(vacation).then(function () {
			vacation.setValidated();
			$state.go('app.business-day');
		}, function () {
			vacation.setUnvalidated()
		})
	}
	
	$scope.collapseTransac = function(id) {
		if (!id) {
			return;
		}
		var transaction = $scope.salesByTransaction[id]
		transaction.opened = !!(transaction.opened ^ true)
	}
	
	$scope.collapseBadTransac = function(id) {
		if (!id) {
			return;
		}
		var transaction = $scope.badSalesByTransaction[id]
		transaction.opened = !!(transaction.opened ^ true)
	}
	
}])